/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useReducer, useState, useEffect, useRef } from "react";
import { initialState, reducer } from "../components/ReducerComponent";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import ThreeDotsLoader from "../components/ThreeDotsLoader";
import FailureModal from "../components/FailureModal";
import { Modal } from "flowbite-react";
import {
  clog,
  getRedirectAfterLogin,
  setRedirectAfterLogin,
} from "../lib/utils";

function Signup() {
  const [loadingState, dispatch] = useReducer(reducer, initialState);
  const documentBodyRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  clog(location, "location");
  const { pathname } = location;
  const origin =
    typeof window !== "undefined" && window.location.origin
      ? window.location.origin
      : "";

  const URL = `${origin}${pathname}`;
  const [signUpdata, setsignUpdata] = useState({
    first_name: "",
    last_name: "",
    email: "",
    af_code: null,
    ref_code: null,
    plan_id: null,
  });
  const [subscribeToModalOpen, setsubscribeToModalOpen] = useState(false);
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const [emailAllowed, setemailAllowed] = useState("");
  const emailref = useRef(null);
  // clog(loadingState, "loading state");

  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setsignUpdata({ ...signUpdata, [id]: value });
  };
  const signUpButton = async (e) => {
    e.preventDefault();
    if (emailAllowed) return; // Prevent submission if email is not allowed
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    dispatch({ type: "LOADING" });
    let data = {
      ...signUpdata,
    };
    delete data.af_code;
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/vison/signup`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      });
      if (response.data.success) {
        dispatch({
          type: "SUCCESS",
          data: {
            successMessage: response.data.message,
          },
        });

        // Use utility function to get redirect info
        const redirectInfo = getRedirectAfterLogin(location?.state);

        navigate("/signup-otp", {
          replace: true,
          state: {
            email: signUpdata.email,
            af_code: signUpdata.af_code,
            ref_code: signUpdata.ref_code,
            from: redirectInfo?.from || "signup",
            url: redirectInfo?.url || "script",
          },
        });
      } else {
        if (response.data.email) {
          setsuccessFailureMessage(response.data.message);
          setopenFailureModal("dismissible");
          dispatch({
            type: "ERROR",
            data: {
              errorMessage: "",
            },
          });
        } else {
          dispatch({
            type: "ERROR",
            data: {
              errorMessage: response.data.message,
            },
          });
        }
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        data: {
          errorMessage: error?.response?.data?.msg,
        },
      });
      clog(error);
    } finally {
      localStorage.removeItem("visonsignupplan");
      localStorage.removeItem("referrer");
      localStorage.removeItem("page_url");
    }
  };
  const callMissingUserApi = async (email) => {
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_LANDING_BE_URL}/missed/user`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          email: email,
          page_name: URL,
        },
      });
      if (response.data.success) {
      } else {
      }
    } catch (error) {
      clog(error);
    }
  };
  // useEffect(() => {
  //   // Extract email from the URL
  //   const urlParams = new URLSearchParams(location.search);
  //   const emailParam = urlParams.get("email");
  //   const af_code = urlParams.get("af_code");
  //   const ref_code = urlParams.get("ref_code");
  //   const plan = urlParams.get("plan");
  //   const referrer = urlParams.get("referrer");
  //   if (emailParam !== null) {
  //     // clog(emailParam, "email param");
  //     callMissingUserApi(emailParam);
  //     setsignUpdata({ ...signUpdata, email: emailParam });
  //     navigate("/signup");
  //   }
  //   if (plan) {
  //     let plan_id = 1;
  //     if (plan === "freemium") {
  //       plan_id = 1;
  //     } else if (plan === "lite") {
  //       plan_id = 2;
  //     } else if (plan === "pro") {
  //       plan_id = 3;
  //     }
  //     localStorage.setItem("visonsignupplan", plan_id);
  //     setsignUpdata({ ...signUpdata, plan_id: plan_id });
  //     navigate("/signup");
  //   } else {
  //     localStorage.setItem("visonsignupplan", 1);
  //   }
  //   if (af_code) {
  //     setsignUpdata({ ...signUpdata, af_code: af_code, ref_code: af_code });
  //     localStorage.setItem("ref_code", af_code);
  //   } else {
  //     localStorage.removeItem("ref_code");
  //   }
  //   if (ref_code) {
  //     setsignUpdata({ ...signUpdata, ref_code: ref_code });
  //     localStorage.setItem("ref_code", ref_code);
  //   } else {
  //     localStorage.removeItem("ref_code");
  //   }
  // }, []);
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const emailParam = urlParams.get("email");
    const af_code = urlParams.get("af_code");
    const ref_code = urlParams.get("ref_code");
    const plan = urlParams.get("plan");
    const referrer = urlParams.get("referrer");
    const page_url = urlParams.get("page_url");
    const priceId = urlParams.get("price_id");
    const period = urlParams.get("period");
    let updatedSignUpData = { ...signUpdata };

    if (emailParam) {
      callMissingUserApi(emailParam);
      updatedSignUpData.email = emailParam;
    }

    if (referrer) {
      updatedSignUpData.referrer = referrer;
      localStorage.setItem("referrer", referrer);
    }

    if (page_url) {
      updatedSignUpData.page_url = page_url;
      localStorage.setItem("page_url", page_url);
    }

    if (plan) {
      // const planMap = { freemium: 1, lite: 2, pro: 3 };
      const plan_id = null;
      localStorage.setItem("visonsignupplan", plan);
      updatedSignUpData.plan_id = plan_id;

      if (plan == "win+" && priceId) {
        updatedSignUpData.price_id = priceId;
        localStorage.setItem("price_id", priceId);
      }
    } else {
      localStorage.setItem("visonsignupplan", "free");
    }

    if (period) {
      updatedSignUpData.period = period;
      localStorage.setItem("period", period);
    }

    if (af_code) {
      updatedSignUpData.af_code = af_code;
      updatedSignUpData.ref_code = af_code;
      localStorage.setItem("ref_code", af_code);
    } else if (ref_code) {
      updatedSignUpData.ref_code = ref_code;
      localStorage.setItem("ref_code", ref_code);
    } else {
      localStorage.removeItem("ref_code");
    }

    setsignUpdata(updatedSignUpData);

    // Navigate only once after processing all parameters
    navigate("/signup");
  }, []);

  const timeoutRef = useRef(null);
  const disallowedDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "mail.com",
    "zoho.com",
    "zoho.in",
    "outlook.com",
    "aol.com",
    "yahoo.in",
    "icloud.com",
    "inbox.ru",
    "mail.ru",
    "yopmail.com",
    "oastify.com",
    "qq.com",
    "jephy-webmail.com",
  ];
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    // setemail(newEmail);
    setsignUpdata({ ...signUpdata, email: newEmail });
    const domain = newEmail.split("@")[1]; // Extract domain
    if (domain && disallowedDomains.includes(domain.toLowerCase())) {
      setemailAllowed(
        `Please enter a different email address. This form does not accept addresses from ${domain}`
      );
    } else {
      setemailAllowed("");
    }
    // Clear any previous timeout when the user is typing
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    const validateEmail = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    // Set a new timeout for 3 seconds after typing stops
    timeoutRef.current = setTimeout(() => {
      if (newEmail && validateEmail(newEmail)) {
        axios
          .post(`${process.env.REACT_APP_LANDING_BE_URL}/missed/user`, {
            email: newEmail,
            page_name: URL,
          })
          .then((response) => {
            clog("API response:", response.data);
          })
          .catch((error) => {
            console.error("API error:", error);
          });
        // Call your API here
        clog("Valid email, calling API...");
      }
    }, 2000);
  };
  // useEffect(() => {
  //   const handleMouseOut = (event) => {
  //     // Trigger when the mouse leaves the viewport (indicating the user might close the tab)
  //     if (!event.relatedTarget && event.clientY < 0) {
  //       sendEmailData();
  //     }
  //   };

  //   const validateEmail = (email) => {
  //     return String(email)
  //       .toLowerCase()
  //       .match(
  //         /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  //       );
  //   };

  //   const sendEmailData = () => {
  //     const emailValue = emailref.current?.value;

  //     if (emailValue && validateEmail(emailValue)) {
  //       axios
  //         .post(`${process.env.REACT_APP_LANDING_BE_URL}/missed/user`, {
  //           email: emailValue,
  //           page_name: URL,
  //         })
  //         .then((response) => {
  //           clog("API response:", response.data);
  //         })
  //         .catch((error) => {
  //           console.error("API error:", error);
  //         });
  //     }
  //   };

  //   window.addEventListener("mouseout", handleMouseOut);

  //   // Cleanup
  //   return () => {
  //     window.removeEventListener("mouseout", handleMouseOut);
  //   };
  // }, []);

  // useEffect(() => {
  //   localStorage.setItem("visonsignupplan", signUpdata?.plan_id);
  // }, [signUpdata?.plan_id]);

  clog(signUpdata, "signup data");
  return (
    <>
      <div className="h-screen">
        <img
          className="loginfram w-full h-full absolute z-[-10]"
          src="images/frame.png"
          alt="..."
        />
        {/* Navigation button to landing page */}
        <div className="absolute top-6 right-8 z-10">
          <button
            type="button"
            onClick={() =>
              window.open(process.env.REACT_APP_LANDING_URL, "_self")
            }
            className="px-6 py-2 rounded-full font-semibold border-2 border-[#1A71A7] text-[#1A71A7] hover:bg-[#1A71A7] hover:text-white transition duration-300 flex items-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Back to Home
          </button>
        </div>
        <div class="flex flex-wrap -mx-6l h-screen">
          <div class="w-full md:w-1/2 px-[80px] flex items-center justify-center">
            <div className="w-[420px]">
              <img className="w-full" src="images/signup.png" alt="..." />
            </div>
          </div>
          <div class="w-full md:w-1/2 px-[80px] flex items-center">
            <form className="w-full" onSubmit={signUpButton}>
              <div
                className="flex justify-center cursor-pointer"
                onClick={() => window.open(process.env.REACT_APP_LANDING_URL)}
              >
                {/* <img src="images/logo.png" alt="..." /> */}
                <img
                  src="images/VisonWithOReplaced.png"
                  width={150}
                  height={50}
                  alt="..."
                />
              </div>
              <h5 className="font-extrabold text-[40px] pb-2 pt-1">Sign Up</h5>
              <div className="mb-[15px]">
                <label
                  className="block mb-[2px] font-semibold text-[20px]"
                  htmlFor="first_name"
                >
                  First Name
                </label>
                <input
                  type="text"
                  className="w-full rounded-full font-[400] text-[20px] border border-[#E9EBF0] bg-[#FAFBFC]"
                  placeholder="Enter first name"
                  id="first_name"
                  required
                  value={signUpdata.first_name}
                  onChange={handleChange}
                  pattern=".*\S+.*"
                />
              </div>
              <div className="mb-[15px]">
                <label
                  class="block mb-[2px] font-semibold text-[20px]"
                  htmlFor="last_name"
                >
                  Last Name
                </label>
                <input
                  type="text"
                  className="w-full rounded-full font-[400] text-[20px] border border-[#E9EBF0] bg-[#FAFBFC]"
                  placeholder="Enter last name"
                  id="last_name"
                  required
                  value={signUpdata.last_name}
                  onChange={handleChange}
                  pattern=".*\S+.*"
                />
              </div>
              <div className="mb-[15px]">
                <label
                  class="block mb-[2px] font-semibold text-[20px]"
                  htmlFor="email"
                >
                  Work Email Address
                </label>
                <input
                  ref={emailref}
                  type="email"
                  className="w-full rounded-full font-[400] text-[20px] border border-[#E9EBF0] bg-[#FAFBFC]"
                  placeholder="Enter email"
                  required
                  id="email"
                  value={signUpdata.email}
                  // onChange={handleChange}
                  onChange={handleEmailChange}
                  pattern="[^@\s]+@[^@\s]+\.[^@\s]+" // Email validation
                  title="Please enter a valid email address"
                />

                {emailAllowed && (
                  <div
                    className="mt-1"
                    style={{
                      color: "red",
                    }}
                  >
                    {emailAllowed}
                  </div>
                )}
              </div>
              {/* <div className="mb-[10px]">
                <label className="block mb-[2px] font-semibold text-[20px]">
                  Subscribe To
                </label>
                <div className="flex flex-row gap-5 text-[18px]">
                  <label className="mb-[5px]">
                    <input
                      type="radio"
                      name="subscription_plan"
                      value="freemium"
                      checked={signUpdata.plan_id === 1}
                      onClick={() => {
                        setsignUpdata({ ...signUpdata, plan_id: 1 });
                      }}
                      required
                    />
                    <span className="ml-1">Freemium</span>
                  </label>
                  <label className="mb-[5px]">
                    <input
                      type="radio"
                      name="subscription_plan"
                      value="lite"
                      checked={signUpdata.plan_id === 2}
                      onClick={() => {
                        setsignUpdata({ ...signUpdata, plan_id: 2 });
                      }}
                      required
                    />
                    <span className="ml-1">Lite 14 days free trial</span>
                  </label>
                  <label className="mb-[5px]">
                    <input
                      type="radio"
                      name="subscription_plan"
                      checked={signUpdata.plan_id === 3}
                      onClick={() => {
                        setsignUpdata({ ...signUpdata, plan_id: 3 });
                      }}
                      value="pro"
                      required
                    />
                    <span className="ml-1">Pro 14 days free trial</span>
                  </label>
                </div>
              </div> */}
              {loadingState.error && (
                <div className="w-full text-[red] py-2 text-center">
                  {loadingState.errorMessage}
                </div>
              )}
              <button
                type="submit"
                disabled={loadingState.loading}
                className="w-full mt-2 justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white  hover:from-[#9D3784] hover:to-[#1A71A7]"
              >
                {loadingState.loading ? (
                  <div className="flex justify-between items-center">
                    <div></div>
                    <div>Signing In</div>
                    <div>
                      <ThreeDotsLoader />
                    </div>
                  </div>
                ) : (
                  "Continue"
                )}
              </button>
              <div
                className="py-2 text-center font-bold text-[18px] cursor-pointer"
                onClick={() => {
                  navigate("/");
                }}
              >
                <span>Already Have An Account </span>
                <a className="text-transparent bg-clip-text bg-gradient-to-r from-[#1A71A7] to-[#9D3784] hover:from-[#9D3784] hover:to-[#1A71A7]">
                  Sign In
                </a>
              </div>
              {/* <hr /> */}
              <h3 className="title-around-span ">
                <span>Or</span>
              </h3>

              <button
                type="button"
                className="w-full my-1 mt-2 justify-center py-2 px-[20px] rounded-[20px] font-semibold border border-[#D73939] text-[#D73939] relative hover:bg-[#D73939] hover:text-[#ffffff] transition duration-700"
                onClick={() => {
                  // Store redirect info before external redirect to Google
                  const redirectInfo = getRedirectAfterLogin(location?.state);
                  if (redirectInfo?.from || redirectInfo?.url) {
                    setRedirectAfterLogin(redirectInfo);
                  }

                  // setsubscribeToModalOpen(true);
                  window.open(
                    `${process.env.REACT_APP_BASE_SIGNIN_URL}/auth/google`,
                    "_self"
                  );
                }}
              >
                <span className="absolute left-[20px] top-[6px]">
                  <svg className="icon text-[28px]">
                    <use href="#icon_google"></use>
                  </svg>
                </span>
                Continue With Google
              </button>
              <div className="bg-red-50 border-2 border-red-400 rounded-lg p-3 mt-3 mb-4">
                <div className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5 text-red-600 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <p className="text-red-700 font-semibold text-sm">
                    Work email only - Gmail and public email providers are not
                    allowed
                  </p>
                </div>
              </div>
              <hr />
              <div className="py-6 text-center">
                <span className="">
                  By continuing, you are agree to Vison's&nbsp;
                  <a
                    href={process.env.REACT_APP_LANDING_URL + "/saas-agreement"}
                    rel="noreferrer"
                    target="_blank"
                    className="text-[#1B5AB9] hover:text-[#9D3784]"
                  >
                    SaaS&nbsp;Agreement,
                  </a>
                  &nbsp;
                  <a
                    href={process.env.REACT_APP_LANDING_URL + "/terms"}
                    rel="noreferrer"
                    target="_blank"
                    className="text-[#1B5AB9] hover:text-[#9D3784]"
                  >
                    Terms of Service
                  </a>
                  &nbsp;and&nbsp;
                  <a
                    href={process.env.REACT_APP_LANDING_URL + "/privacy"}
                    rel="noreferrer"
                    target="_blank"
                    className="text-[#1B5AB9] hover:text-[#9D3784]"
                  >
                    Privacy Policy
                  </a>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
      <FailureModal
        open={openFailureModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
        from="signup"
        email={signUpdata.email}
      />
      {/* <Modal
        root={documentBodyRef.current}
        dismissible
        show={subscribeToModalOpen}
        size="2xl"
        onClose={() => setsubscribeToModalOpen(false)}
      >
        <Modal.Header className="capitalize py-2">
          <h6 className="font-bold text-[24px]">
            <label className="block mb-[2px] font-semibold text-[20px]">
              Subscribe To
            </label>
          </h6>
        </Modal.Header>
        <Modal.Body className="pt-2">
          <div className="mb-[10px]">
            <div className="flex flex-row gap-5 text-[18px]">
              <label className="mb-[5px]">
                <input
                  type="radio"
                  name="subscription_plan"
                  value="freemium"
                  checked={signUpdata.plan_id === 1}
                  onClick={() => {
                    setsignUpdata({ ...signUpdata, plan_id: 1 });
                  }}
                  required
                />
                <span className="ml-1">Freemium</span>
              </label>
              <label className="mb-[5px]">
                <input
                  type="radio"
                  name="subscription_plan"
                  value="lite"
                  checked={signUpdata.plan_id === 2}
                  onClick={() => {
                    setsignUpdata({ ...signUpdata, plan_id: 2 });
                  }}
                  required
                />
                <span className="ml-1">Lite 14 days free trial</span>
              </label>
              <label className="mb-[5px]">
                <input
                  type="radio"
                  name="subscription_plan"
                  checked={signUpdata.plan_id === 3}
                  onClick={() => {
                    setsignUpdata({ ...signUpdata, plan_id: 3 });
                  }}
                  value="pro"
                  required
                />
                <span className="ml-1">Pro 14 days free trial</span>
              </label>
            </div>
            <button
              type="button"
              className="w-full  mt-3 justify-center py-2 px-[20px] rounded-[20px] font-semibold border border-[#D73939] text-[#D73939] relative hover:bg-[#D73939] hover:text-[#ffffff] transition duration-700"
              onClick={() => {
                // Store redirect info before external redirect to Google
                const redirectInfo = getRedirectAfterLogin(location?.state);
                if (redirectInfo?.from || redirectInfo?.url) {
                  setRedirectAfterLogin(redirectInfo);
                }
                
                // setsubscribeToModalOpen(true);
                window.open(
                  `${process.env.REACT_APP_BASE_SIGNIN_URL}/auth/google`,
                  "_self"
                );
              }}
            >
              <span className="absolute left-[20px] top-[6px]">
                <svg className="icon text-[28px]">
                  <use href="#icon_google"></use>
                </svg>
              </span>
              Continue With Google
            </button>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
}

export default Signup;
